import UNINITIALISED from "utils/uninitialised";
import ActionTypes from "../constants/action_types";

export default function taskReducer(state = UNINITIALISED, action) {
  switch (action.type) {
    case ActionTypes.TASKROLES_FETCH.SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
